<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="htit1"><span class="bold">A SELECTIVE HISTORY OF</span></p>
<p class="htit2"><span class="bold">‘BAD’</span></p>
<p class="htit3"><span class="bold">VIDEO GAMES</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 1_Halftitle.vue?44223eba